import * as React from 'react';

import { Select } from 'antd';

interface AccountsMultiSelectProps {
  value: string[];
  onChange: (ids: string[]) => void;
  options: { id: string; name: string }[];
  mode?: 'single' | 'multiple';
  disabled?: boolean;
  loading?: boolean;
  error?: boolean;
}

export function AccountsMultiSelect({ value, onChange, options, mode = 'multiple', disabled, loading, error }: AccountsMultiSelectProps) {
  return (
    <Select
      mode={mode === 'single' ? undefined : 'multiple'}
      allowClear
      showSearch
      value={value}
      onChange={(vals) => {
        if (mode === 'single') {
          onChange(vals ? [vals as unknown as string] : []);
        } else {
          onChange(Array.isArray(vals) ? vals : []);
        }
      }}
      placeholder={mode === 'single' ? 'Выберите кабинет' : 'Выберите кабинет(ы)'}
      style={{
        width: '100%',
        ...(error ? {
          borderColor: '#ff4d4f',
        } : {})
      }}
      status={error ? 'error' : undefined}
      dropdownStyle={{ background: '#fff' }}
      filterOption={(input, option: any) => option?.children?.toLowerCase().includes(input.toLowerCase())}
      maxTagCount={10}
      disabled={disabled}
      loading={loading}
    >
      {options.map((option) => (
        <Select.Option key={option.id} value={option.id}>
          {option.name}
        </Select.Option>
      ))}
    </Select>
  );
}
